const OCR_COUNT = 'OCR_COUNT';
const OCR_PDF_COUNT = 'OCR_PDF_COUNT';
const OCR_STACK = 'OCR_STACK_1';
const USER_LANGUAGE = 'USER_LANGUAGE';
const SHOW_HOW_TO_USE_POPUP = 'SHOW_HOW_TO_USE_POPUP'

export { OCR_COUNT, OCR_PDF_COUNT, OCR_STACK, USER_LANGUAGE, SHOW_HOW_TO_USE_POPUP };
